import Vue from 'vue'

import validationRules from './validationRules';
Vue.mixin(validationRules);

import global from './global';
Vue.mixin(global);

import cards from './cards';
Vue.mixin(cards);